<template>
  <Teleport to="body">
    <!-- 遮罩层 -->
    <div v-if="visible" class="modal-overlay" @click="closeModal"></div>

    <!-- 友情链接申请 Modal 弹窗 -->
    <transition name="modal-fade">
      <div v-if="visible" class="apply-link-modal blur-card" role="dialog" aria-modal="true" aria-labelledby="apply-modal-title">
        <!-- 关闭按钮 -->
        <button class="close-btn" @click="closeModal" aria-label="关闭">&times;</button>

        <h3 id="apply-modal-title" class="modal-title">
          <i class="fa-solid fa-link"></i> 申请友情链接
        </h3>
        <p class="modal-intro">欢迎交换友情链接，请确保您的站点能正常访问且无不良内容。</p>
        
        <form @submit.prevent="submitApplication" style="display:flex; flex-direction:column; gap:12px;">
          <div class="form-group">
            <label>网站名称 <span class="required">*</span></label>
            <input 
              v-model="applyForm.name" 
              type="text" 
              placeholder="网站显示名称，例如：雨景小站" 
              required
              class="form-input"
            />
          </div>
          
          <div class="form-group">
            <label>网站链接 <span class="required">*</span></label>
            <input 
              v-model="applyForm.link" 
              type="url" 
              placeholder="必须以 http:// 或 https:// 开头" 
              required
              class="form-input"
            />
          </div>
          
          <div class="form-row">
            <div class="form-group" style="flex:1;">
              <label>浅色 Logo (选填)</label>
              <input 
                v-model="applyForm.logo" 
                type="text" 
                placeholder="Logo相对或绝对链接" 
                class="form-input"
              />
            </div>
            <div class="form-group" style="flex:1;">
              <label>深色 Logo (选填)</label>
              <input 
                v-model="applyForm.logoDark" 
                type="text" 
                placeholder="留空默认同浅色" 
                class="form-input"
              />
            </div>
          </div>
          
          <div class="form-group">
            <label>网站简介/描述 <span class="required">*</span></label>
            <textarea 
              v-model="applyForm.description" 
              rows="3" 
              placeholder="一句话介绍您的站点，将在合作伙伴致谢列表中作为卡片描述显示" 
              required
              class="form-textarea"
            ></textarea>
          </div>

          <div class="modal-actions">
            <button type="button" class="cancel-button" @click="closeModal">
              取消
            </button>
            <button type="button" class="clear-button" @click="clearForm">
              清空
            </button>
            <button type="submit" class="confirm-button" :disabled="submitting">
              <i class="fa-solid fa-spinner fa-spin mr-1" v-if="submitting"></i>
              提交申请
            </button>
          </div>
        </form>
      </div>
    </transition>
  </Teleport>
</template>

<script>
import authService from '@/services/authService'
import { message } from '@/utils/ui-service'
import { BaseServerUrl } from '@/assets/BaseServerUrl.js'
import axios from 'axios'

export default {
  name: 'FriendLinkApplyModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitting: false,
      applyForm: {
        name: '',
        link: '',
        logo: '',
        logoDark: '',
        description: ''
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:visible', false)
    },
    clearForm() {
      this.applyForm = {
        name: '',
        link: '',
        logo: '',
        logoDark: '',
        description: ''
      }
    },
    async submitApplication() {
      if (!this.applyForm.name || !this.applyForm.link || !this.applyForm.description) {
        message.warning('网站名称、链接和简介为必填项！')
        return
      }
      
      if (!this.applyForm.link.startsWith('http://') && !this.applyForm.link.startsWith('https://')) {
        message.warning('链接必须以 http:// 或 https:// 开头！')
        return
      }

      this.submitting = true
      try {
        const token = authService.getLocalToken()
        const headers = token ? { Authorization: `Bearer ${token}` } : {}
        const res = await axios.post(`${BaseServerUrl}/api/friendlinks/apply`, this.applyForm, { headers })
        
        if (res.data && res.data.success) {
          message.success('友链申请提交成功，请等待管理员审核！')
          this.clearForm()
          this.closeModal()
        } else {
          message.error(res.data.error || '提交申请失败')
        }
      } catch (e) {
        message.error(e.response?.data?.error || '服务器连接失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: var(--z-critical);
  transition: opacity 0.3s ease;
}

.apply-link-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  max-width: 90%;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  z-index: calc(var(--z-critical) + 1);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

body.dark-theme .apply-link-modal,
.dark-theme .apply-link-modal {
  background: rgba(30, 30, 30, 0.85);
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 18px;
  background: none;
  border: none;
  font-size: 1.6em;
  cursor: pointer;
  color: #8e8e93;
  transition: color 0.2s ease;
}

.close-btn:hover {
  color: #ff4d4f;
}

.modal-title {
  margin: 0 0 6px 0;
  font-size: 1.35em;
  font-weight: 600;
  font-family: '爱点风雅黑', sans-serif;
  color: #1d1d1f;
  display: flex;
  align-items: center;
  gap: 8px;
}

body.dark-theme .modal-title,
.dark-theme .modal-title {
  color: #f5f5f7;
}

.modal-intro {
  font-size: 0.88em;
  color: #6e6e73;
  margin: 0 0 16px 0;
  font-family: '猫啃网糖圆体', sans-serif;
  text-align: left;
}

body.dark-theme .modal-intro,
.dark-theme .modal-intro {
  color: #86868b;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 12px;
  text-align: left;
}

.form-group label {
  font-size: 0.88em;
  font-weight: 600;
  color: #1d1d1f;
  font-family: '爱点风雅黑', sans-serif;
}

body.dark-theme .form-group label,
.dark-theme .form-group label {
  color: #f5f5f7;
}

.form-input, .form-textarea {
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  outline: none;
  background: rgba(255, 255, 255, 0.8);
  font-size: 0.9em;
  color: #1d1d1f;
  box-sizing: border-box;
}

body.dark-theme .form-input, 
body.dark-theme .form-textarea,
.dark-theme .form-input,
.dark-theme .form-textarea {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: #f5f5f7;
}

.form-input:focus, .form-textarea:focus {
  border-color: #0071e3;
  box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.15);
}

body.dark-theme .form-input:focus, 
body.dark-theme .form-textarea:focus,
.dark-theme .form-input:focus,
.dark-theme .form-textarea:focus {
  border-color: #0071e3;
  box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.3);
}

.form-row {
  display: flex;
  gap: 12px;
}

.required {
  color: #ff4d4f;
  margin-left: 2px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 15px;
}

.cancel-button, .clear-button, .confirm-button {
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9em;
  font-weight: 500;
  cursor: pointer;
  border: none;
  outline: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.cancel-button {
  background: rgba(0, 0, 0, 0.06);
  color: #333;
}

body.dark-theme .cancel-button,
.dark-theme .cancel-button {
  background: rgba(255, 255, 255, 0.08);
  color: #eee;
}

.clear-button {
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: #555;
}

body.dark-theme .clear-button,
.dark-theme .clear-button {
  border-color: rgba(255, 255, 255, 0.2);
  color: #ccc;
}

.confirm-button {
  background: #0071e3;
  color: #fff;
}

.confirm-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.mr-1 {
  margin-right: 4px;
}

/* 动效 */
.modal-fade-enter-active, .modal-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.modal-fade-enter-from, .modal-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -45%) scale(0.95);
}

@media (max-width: 580px) {
  .apply-link-modal {
    width: 95%;
    padding: 16px;
  }
  .form-row {
    flex-direction: column;
    gap: 0;
  }
}
</style>
